import * as React from 'react';
import { calcDurationToNow, useInterval } from '../../shared';

type Props = {
  createdAt: string
};

export function ClientListTimer({createdAt}: Props) {
  const [time, setTime] = React.useState<string>();
  useInterval(() => {
    setTime(calcDurationToNow(createdAt));
  }, 1000);

  return (
    <>
      {time}
    </>
  );
}
